import { TIP } from "../lib/glossary";

/** An underlined term that reveals a plain-English definition on hover. */
export function Term({ children, k }: { children: string; k?: string }) {
  const key = (k ?? children).toLowerCase();
  const html = TIP[key] ?? "<b>" + children + "</b>";
  return (
    <span className="term">
      {children}
      <span className="tip" dangerouslySetInnerHTML={{ __html: html }} />
    </span>
  );
}
